import { isValidCorrelationId } from './correlationIdValidation';

export const CORRELATION_ID_COOKIE_NAME = 'correlation-id';
export const CORRELATION_ID_HEADER_NAME = 'x-correlation-id';
export const CORRELATION_ID_META_NAME = 'x-correlation-id';
export const CORRELATION_ID_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 7;

export const generateCorrelationId = (): string => {
    const timestamp = Date.now();
    const randomPart = Math.floor(Math.random() * 1000000)
        .toString()
        .padStart(6, '0');
    return `${timestamp}${randomPart}`;
};

/**
 * Returns the current request/session correlation id, or mints one.
 * Browser: `<meta name="x-correlation-id">` rendered by the server layout.
 * Server: `x-correlation-id` header, then cookie, then mint.
 */
export const getCorrelationId = async (): Promise<string> => {
    if (typeof window !== 'undefined') {
        const meta = document.querySelector(`meta[name="${CORRELATION_ID_META_NAME}"]`);
        const value = meta?.getAttribute('content');
        return isValidCorrelationId(value) ? value : generateCorrelationId();
    }

    // Playwright test runner (Node.js, no Next.js server context)
    if (process.env.TEST_WORKER_INDEX !== undefined) {
        return generateCorrelationId();
    }

    try {
        const { cookies, headers } = await import('next/headers');
        const requestHeaders = await headers();
        const headerCorrelationId = requestHeaders.get(CORRELATION_ID_HEADER_NAME);
        if (isValidCorrelationId(headerCorrelationId)) {
            return headerCorrelationId;
        }

        const cookieStore = await cookies();
        const cookieCorrelationId = cookieStore.get(CORRELATION_ID_COOKIE_NAME)?.value;
        return isValidCorrelationId(cookieCorrelationId)
            ? cookieCorrelationId
            : generateCorrelationId();
    } catch {
        return generateCorrelationId();
    }
};
